"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exchangeOrder = exports.getFeeReduction = exports.exchangeOrderWithConnection = void 0;
const anchor_1 = require("@project-serum/anchor");
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const state_1 = require("../state");
const util_1 = require("../util");
/**
 * Executes an exchange with Solana connection
 * Takes a connection to fetch necessary accounts - it is preferred to use `exchangeAccount`
 * @param connection - Connection
 * @param orderAccount - Order Account
 * @param orderTaker - Order taker Account
 * @param orderTakerDepositTokenAccount - Taker deposit Token Account
 * @param purchaseQty - Purchase quantity
 * @param expectedPrice - Expected Price
 * @param saVault - Star Atlas vault account
 * @param stakingProgramId - Staking program ID
 * @param registeredStake - Registered Stake key
 * @param stakingAccount - Staking Account
 * @param program - GalacticMarketplace Program
 * @param extraAccounts - Extra accounts, used for buddy link
 * @returns InstructionReturn
 */
function exchangeOrderWithConnection(connection, orderAccount, orderTaker, orderTakerDepositTokenAccount, purchaseQty, expectedPrice, saVault, stakingProgramId, registeredStake, stakingAccount, program, extraAccounts = []) {
    return __awaiter(this, void 0, void 0, function* () {
        const instructions = [];
        const orderSide = (0, util_1.getOrderSide)(orderAccount);
        const orderInitializer = orderAccount.data.orderInitializerPubkey;
        const initializerDepositMint = orderSide === 'SellSide'
            ? orderAccount.data.assetMint
            : orderAccount.data.currencyMint;
        const initializerReceiveMint = orderSide === 'SellSide'
            ? orderAccount.data.currencyMint
            : orderAccount.data.assetMint;
        // Find initializer deposit account
        let initializerDepositTokenAccount;
        let response = yield (0, util_1.getTokenAccount)(connection, orderInitializer, initializerDepositMint, orderTaker.publicKey());
        if ('createInstruction' in response) {
            instructions.push(response.createInstruction);
        }
        if (response.tokenAccount instanceof web3_js_1.Keypair) {
            initializerDepositTokenAccount = response.tokenAccount.publicKey;
        }
        else {
            initializerDepositTokenAccount = response.tokenAccount;
        }
        // Find initializer receive account
        let initializerReceiveTokenAccount;
        response = yield (0, util_1.getTokenAccount)(connection, orderInitializer, initializerReceiveMint, orderTaker.publicKey());
        if ('createInstruction' in response) {
            instructions.push(response.createInstruction);
        }
        if (response.tokenAccount instanceof web3_js_1.Keypair) {
            initializerReceiveTokenAccount = response.tokenAccount.publicKey;
        }
        else {
            initializerReceiveTokenAccount = response.tokenAccount;
        }
        // Find order taker receive account
        let orderTakerReceiveTokenAccount;
        response = yield (0, util_1.getTokenAccount)(connection, orderInitializer, initializerDepositMint);
        if ('createInstruction' in response) {
            instructions.push(response.createInstruction);
        }
        if (response.tokenAccount instanceof web3_js_1.Keypair) {
            orderTakerReceiveTokenAccount = response.tokenAccount.publicKey;
        }
        else {
            orderTakerReceiveTokenAccount = response.tokenAccount;
        }
        const exchangeInstruction = exchangeOrder(program, orderAccount, orderTaker, purchaseQty, expectedPrice, initializerDepositTokenAccount, initializerReceiveTokenAccount, orderTakerDepositTokenAccount, orderTakerReceiveTokenAccount, saVault, stakingProgramId, registeredStake, stakingAccount, extraAccounts);
        instructions.push(exchangeInstruction);
        return instructions;
    });
}
exports.exchangeOrderWithConnection = exchangeOrderWithConnection;
/**
 * Get the address of a Fee Exemption account
 * @param program - GalacticMarketplace Program
 * @param seller - the seller
 * @returns the PDA and bump
 */
function getFeeReduction(program, seller) {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from('fee_exempt'), seller.toBuffer()], program.programId);
}
exports.getFeeReduction = getFeeReduction;
/**
 * Executes an exchange
 * @param program - GalacticMarketplace Program
 * @param orderAccount - the order account
 * @param orderTaker - the order take
 * @param purchaseQty - the purchase quantity in base units
 * @param expectedPrice - the expected price in base units
 * @param initializerDepositTokenAccount - the initializer deposit token account
 * @param initializerReceiveTokenAccount - the initializer receiving token account
 * @param orderTakerDepositTokenAccount - the order taker deposit token account
 * @param orderTakerReceiveTokenAccount - the order taker receiving token account
 * @param saVault - Star Atlas vault account - must match account in registered currency
 * @param stakingProgramId - the ATLAS staking program
 * @param registeredStake - Atlas `RegisteredStake` Account
 * @param stakingAccount - User's Atlas staking account
 * @param extraAccounts - Extra accounts, used for buddy link
 * @returns InstructionReturn
 */
function exchangeOrder(program, orderAccount, orderTaker, purchaseQty, expectedPrice, initializerDepositTokenAccount, initializerReceiveTokenAccount, orderTakerDepositTokenAccount, orderTakerReceiveTokenAccount, saVault, stakingProgramId, registeredStake, stakingAccount, extraAccounts = []) {
    const seller = web3_js_1.PublicKey.default;
    const orderSide = (0, util_1.getOrderSide)(orderAccount);
    const initializerDepositMint = orderSide === 'SellSide'
        ? orderAccount.data.assetMint
        : orderAccount.data.currencyMint;
    const orderInitializer = orderAccount.data.orderInitializerPubkey;
    const [feeReduction] = getFeeReduction(program, seller);
    return () => __awaiter(this, void 0, void 0, function* () {
        return ({
            instruction: yield program.methods
                .processExchange(new anchor_1.BN(purchaseQty), expectedPrice, seller)
                .accountsStrict({
                openOrdersCounter: state_1.OpenOrdersCounter.findAddress(program, orderInitializer, initializerDepositMint)[0],
                orderAccount: orderAccount.key,
                orderInitializer,
                orderVaultAccount: state_1.Order.getOrderVaultAddress(program, orderInitializer, initializerDepositMint)[0],
                orderVaultAuthority: state_1.Order.getOrderVaultAuthorityAddress(program, orderInitializer)[0],
                initializerDepositTokenAccount,
                initializerReceiveTokenAccount,
                registeredCurrency: state_1.RegisteredCurrency.findAddress(program, orderAccount.data.currencyMint)[0],
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                orderTaker: orderTaker.publicKey(),
                orderTakerDepositTokenAccount,
                orderTakerReceiveTokenAccount,
                currencyMint: orderAccount.data.currencyMint,
                assetMint: orderAccount.data.assetMint,
                saVault,
                atlasStaking: stakingProgramId,
                registeredStake,
                stakingAccount,
                feeReduction,
            })
                .remainingAccounts(extraAccounts)
                .instruction(),
            signers: [orderTaker],
        });
    });
}
exports.exchangeOrder = exchangeOrder;
//# sourceMappingURL=exchangeOrder.js.map